import * as React from 'react';
import { FeatureFlagsHashMap } from '../types';

interface FeatureFlagsContextState {
  data: FeatureFlagsHashMap;
  loading: boolean;
  error: Error | null;
}
/**
 * @deprecated Use useFeatureFlag instead
 */
export const FeatureFlagsContext = React.createContext<FeatureFlagsContextState>({
  data: {},
  loading: false,
  error: null,
});

export default FeatureFlagsContext;
